<div class="mb-3">
  <div class="d-flex align-items-center justify-content-between mb-2">
    <label class="form-label fw-semibold mb-0">Allowances</label>
    <button type="button" class="btn btn-success btn-sm" (click)="openAddAllowance()">
      <fa-icon [icon]="faPlus"></fa-icon> Add Allowance
    </button>
  </div>

  <div *ngFor="let allowance of allowances" class="d-flex align-items-center gap-2 mb-2">
    <label class="form-label mb-0 fw-semibold" style="min-width: 150px;">{{allowance.description}}</label>
    <div class="input-group input-group-sm" style="width: 150px;">
      <span class="input-group-text">£</span>
      <input type="number" class="form-control" [value]="allowance.amount" readonly>
    </div>
    <button type="button" class="btn btn-link text-danger p-0"
      (click)="deleteAllowance(allowance.allowanceId)">
      <fa-icon [icon]="faTimes"></fa-icon>
    </button>
  </div>
</div>